import { resolveBranchLink } from '@/models/linking/deeplink-resolver'

export function redirectSystemPath({
  path,
  initial
}: {
  path: string
  initial?: boolean
}) {
  console.log('LOG: > redirectSystemPath > path, initial:', path, initial)
  try {
    // A Branch link carries its route in `$deeplink_path`; routing its own path would land on `/`.
    return resolveBranchLink(path) ?? path
  } catch {
    // Do not crash inside this function! Instead you should redirect users
    // to a custom route to handle unexpected errors, where they are able to report the incident
    return '/unexpected-error'
  }
}

// xcrun simctl openurl booted pokerpowher://join/ef9e4d
